<div #bottomSheet class="sheet mat-elevation-z3">
  <div class="handle-region">
    <div class="handle"></div>
  </div>

  <div class="content px-1 pb-3">
    <ng-content></ng-content>
  </div>
</div>
